exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".g2item {\n  display: flex;\n  width: 100%;\n  min-height: 200px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.g2item .g2label {\n  display: flex;\n  box-sizing: content-box;\n  width: 16px;\n  font-size: 16px;\n  align-items: center;\n  padding-right: 10px;\n  word-break: break-all;\n}\n.g2item .g2container {\n  width: 100%;\n}\n.g2item1 {\n  display: flex;\n  width: 100%;\n  min-height: 400px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n}\n.g2item1 .g2label1 {\n  display: flex;\n  box-sizing: content-box;\n  width: 16px;\n  font-size: 16px;\n  align-items: center;\n  padding-right: 5px;\n  word-break: break-all;\n}\n.g2item1 .g2container1 {\n  width: 100%;\n}\n.moduleBox {\n  display: flex;\n  flex-direction: column;\n  height: 750px;\n}\n.moduleBox .g2item1 {\n  flex: 1;\n}\n.kongMsg {\n  width: 100%;\n  line-height: 500px;\n  height: 500px;\n  font-size: 16px;\n  color: #ccc;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/AntD/assets/stylus/com/display/process.styl
// module id = 4464
// module chunks = 0